import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import CampaignService from '@forwardflow/services/CampaignService'
import { useAppStore } from '@forwardflow/store'
import { PaginationQueryParams } from '@forwardflow/types'
import { useOrgSWR } from '../useOrgSWR'

export const useActiveCampaigns = (queryParams: PaginationQueryParams) => {
   const { currentOrganization } = useAppStore()
   const response = useOrgSWR(
      [
         QUERY_KEYS.GET_ALL_ACTIVE_CAMPAIGNS,
         { ...queryParams, organizationId: currentOrganization },
      ],
      () => CampaignService.getActiveCampaigns(queryParams)
   )
   return {
      ...response,
   }
}
